import {
  FeedBackResponseStateTypes,
  FeedBackResponseActionTypes,
} from "./FeedBackResponse.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FeedBackResponseStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FeedBackResponseReducer = (
  state: FeedBackResponseStateTypes = INITIAL_STATE,
  action: any
): FeedBackResponseStateTypes => {
  switch (action.type) {
    case FeedBackResponseActionTypes.FETCH_ALL_FEED_BACK_RESPONSE:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FeedBackResponseActionTypes.FETCH_ALL_FEED_BACK_RESPONSE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FeedBackResponseActionTypes.FETCH_ALL_FEED_BACK_RESPONSE_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FeedBackResponseActionTypes.FETCH_ALL_FEED_BACK_RESPONSE_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FeedBackResponseActionTypes.FETCH_ONE_FEED_BACK_RESPONSE:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FeedBackResponseActionTypes.FETCH_ONE_FEED_BACK_RESPONSE_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState({}),
      };
    case FeedBackResponseActionTypes.FETCH_ONE_FEED_BACK_RESPONSE_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FeedBackResponseActionTypes.FETCH_ONE_FEED_BACK_RESPONSE_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FeedBackResponseReducer;
